import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Pagination, Input, Row, Col, Select, Form, DatePicker, message, Card } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { CSVLink } from 'react-csv';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { MDBBtn, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';
import { dateConverter } from '../../utils/utcDateConversion';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import getCauseByOrg from '../../hooks/getCauseByOrg';
import fetchCauses from '../../hooks/fetchCauses';
import NoRecordFound from '../../components/common/NoRecordFound';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import fetchDonorList from '../../hooks/fetchDonorList';
import { removeDuplicatesByKey } from '../../components/common/removeDuplicatesByKey';
import moment from 'moment';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';

function RecurringDetails() {
  const user = JSON.parse(localStorage.getItem('user'));
  const donorIdforRecurring = localStorage.getItem('donorIdforRecurring');
  console.log(donorIdforRecurring)
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  function goBack() {
    if (user.userType === 'A') navigate('/donor/view', { replace: true });
    else if (user.userType === 'O') navigate('/orgreport/donors', { replace: true });
  }
  window.addEventListener('popstate', goBack);

  let orgResp = useFetchOrganizations();
  console.log(orgResp);
  let orgObj = orgResp.response ? orgResp.response.data : [];
  console.log(orgObj);
  let donorListResp = fetchDonorList();
  let donorList = donorListResp.response ? donorListResp.response.data : [];
  console.log(donorList);
  let donorArray = [];
  user.userType == 'A'
    ? donorList.forEach((ele) => {
        donorArray.push({ value: ele.donorId, label: ele.firstName + ' ' + (ele.lastName ? ele.lastName : ' ') });
      })
    : ' ';
  console.log(donorArray);
  const [editbtn, setEditBtn] = useState('none');
  const [reportObj, setReportObj] = useState({});
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchUsers, setFetchUsers] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState()
  // const [renderList, setRenderList] = useState([
  //   {
  //     "recurringId": 262,
  //     "mxPortalContractId": "617",
  //     "mxRecurrContractId": "10000000025340",
  //     "organizationId": 115,
  //     "kioskId": null,
  //     "kioskTitle": null,
  //     "creationDate": "2025-03-10T09:35:12.000Z",
  //     "paymentInterval": "Weekly",
  //     "dayType": "Day",
  //     "dayNumber": " ",
  //     "paymentDay": "Monday",
  //     "occurrences": "01",
  //     "organizationName": "Masjid Al-Aqsa",
  //     "cause": "Education",
  //     "donorId": 847,
  //     "firstName": "Darakhsha",
  //     "lastName": "Sarwar",
  //     "amount": "2323",
  //     "isActive": "Active",
  //     "startDate": "2025-04-09T04:00:00.000Z"
  //   },
  //   {
  //     "recurringId": 261,
  //     "mxPortalContractId": "616",
  //     "mxRecurrContractId": "10000000025339",
  //     "organizationId": 128,
  //     "kioskId": null,
  //     "kioskTitle": null,
  //     "creationDate": "2025-03-10T09:27:14.000Z",
  //     "paymentInterval": "Monthly",
  //     "dayType": "Day",
  //     "dayNumber": "29",
  //     "paymentDay": "Monday",
  //     "occurrences": "11",
  //     "organizationName": "Testing Organization",
  //     "cause": "Madarsa Donation",
  //     "donorId": 847,
  //     "firstName": "Darakhsha",
  //     "lastName": "Sarwar",
  //     "amount": "1111",
  //     "isActive": "Active",
  //     "startDate": "2025-04-09T04:00:00.000Z"
  //   },
  //   {
  //     "recurringId": 260,
  //     "mxPortalContractId": "615",
  //     "mxRecurrContractId": "10000000024411",
  //     "organizationId": 128,
  //     "kioskId": null,
  //     "kioskTitle": null,
  //     "creationDate": "2024-12-13T13:19:43.000Z",
  //     "paymentInterval": "Monthly",
  //     "dayType": "Day",
  //     "dayNumber": "12",
  //     "paymentDay": "",
  //     "occurrences": "45",
  //     "organizationName": "Testing Organization",
  //     "cause": "Madarsa Donation",
  //     "donorId": 234,
  //     "firstName": "hussain",
  //     "lastName": "Jawed",
  //     "amount": "5",
  //     "isActive": "Cancelled",
  //     "startDate": "2025-01-12T05:00:00.000Z"
  //   }]);
  const [donorDataList, setDonorDataList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [basicModal, setBasicModal] = useState(false);
  const [currRecurr, setCurrRecurr] = useState({});
  const [paymentDetils, setPaymentDetails] = useState([]);
  const [paymentModal, setPaymentModal] = useState(false);
  const [cancelShow, setCancelShow] = useState(false);

  const [donorId, setDonorId] = useState();
  const [err, setErr] = useState('');
  const [recurrings, setRecurrings] = useState(0);
  const [form] = Form.useForm();
  const [isload, setisload] = useState(false)
  const [orderCancelResp, setOrderCancelResp] = useState();

  const [visible, setisvisible] = useState(true)
  let causeResp, causes;
  user.userType == 'A' ? (causeResp = fetchCauses()) : (causeResp = getCauseByOrg(user.organizationId));
  causes = causeResp.response ? causeResp.response.data : [];
  console.log(window.location.pathname)
  useEffect(() => {
    if (window.location.pathname === '/recurring/bydoner'||window.location.pathname==='/recurring/bydonerorg'){
      console.log('Path matched')
      setDonorId(donorIdforRecurring)
    } ;
  }, [window.location.pathname]);
  console.log(donorId)
  const u = useFetchUsers();
  console.log(u);
  const onPaymentClick = (value) => {
    console.log(value);
    localStorage.setItem('recurringObj', JSON.stringify(value));
    navigate('/reports/recurrdetails', { replace: true });
  };
  const token = getTokenfromUserObj();
  const toggleShow = (val) => {
    console.log('val');
    console.log(val);
    val?.isActive && val.isActive == 'Cancelled' ? setisvisible(false) : setisvisible(true);
    setCurrRecurr(val);
    setBasicModal(!basicModal);
  };

  const togglePaymentShow = () => {
    setPaymentModal(!paymentModal);
  };
  const userCount = u.response ? u.response.data.length : 0;
  console.log(userCount);
  console.log(window.location.pathname);
  let newStartDate;
  let newEndDate;
  const fetchRecurrings = async (orgId = null, start = null, end = null,donorId) => {
    let query;
    console.log("donorId")
    console.log(donorId)
    if (orgId || start || end || donorId) {
      query = `recurrpayment/view?organizationId=${orgId}&startDate=${start}&endDate=${end}&donorId=${donorId?donorId:null}`;
    } else {
      query = 'recurrpayment/view';
    }
    let res = await axios.get(`${app.URL}/${query}`, { headers: { auth: token } });
    // console.log(res);
    res.data.success && setRecurrings(res.data.data.totalAmount ? res.data.data.totalAmount : 0);
  };
  const fetchData = async (obj) => {
    console.log(obj);

    const limit = 1000;
    const offset = 0;
    obj.limit = limit;
    obj.offset = offset;
    obj.organization = user.organizationId;
    obj.organizationId = obj.organizationId ? obj.organizationId : null;
    obj.donorId = donorId ? donorId : null;
    obj.causeId = reportObj.causeId;
    obj.startDate = reportObj.startDate;
    obj.endDate = reportObj.endDate;
    obj.status = reportObj.status;
    if (reportObj.startDate > reportObj.endDate) return;
    let searchQuery;
    console.log(user.organizationId);
    // if (window.location.pathname === '/reports/recurring' && user.userType === 'A') fetchRecurrings(obj.organizationId, obj.startDate && obj.startDate.slice(0, 10), obj.endDate && obj.endDate.slice(0, 10));
    if (window.location.pathname === '/orgreport/recurring' && window.location.pathname !== '/recurring/bydonerorg' && user.userType === 'O') {
      searchQuery = `${app.URL}/recurring/viewbyorg?orgId=${user.organizationId}&donorId=${donorId}`;
      fetchRecurrings(user.organizationId, obj.startDate && obj.startDate.slice(0, 10), obj.endDate && obj.endDate.slice(0, 10),obj.donorId&&obj.donorId);
    }
    if (window.location.pathname === '/recurring/bydoner' && user.userType === 'A') searchQuery = `${app.URL}/recurring/viewbydonorid/${donorIdforRecurring}`;
    if (window.location.pathname === '/reports/recurring' && user.userType === 'A') {
      searchQuery = `${app.URL}/recurring/view`;
      fetchRecurrings(obj.organizationId, obj.startDate && obj.startDate.slice(0, 10), obj.endDate && obj.endDate.slice(0, 10));
    }
    if (window.location.pathname === '/recurring/bydonerorg' && user.userType === 'O') searchQuery = `${app.URL}/recurring/viewbydonorandorg/${donorIdforRecurring}/${user.organizationId}`;
    if (user.userType === 'O' && window.location.pathname === '/orgdonor/donationhistory') searchQuery = `${app.URL}/trans/viewbydonorandorg/${donorId}/${user.organizationId}`;
    console.log(searchQuery);
    const tr = await axios.post(searchQuery, obj, { headers: { auth: token } });
    console.log(tr);
    let dateConv;
    tr.data ? (dateConv = dateConverter(tr.data.data, 'startDate')) : ' ';
    tr.data ? setCurrent(1) : 0;
    // let convertedData= tr.data?dateConverter(tr.data.data,'startDate'):console.log("done");
    // convertedData=tr.data?dateConverter(convertedData,'endDate'):console.log("done");
    tr.data ? setFetchUsers(dateConv) : console.log(0);
    tr.data ? setRenderList(dateConv.slice(0, 50)) || setPagesCount(tr.data.data.length) : [];
  };

  const onFinish = (values) => {
    console.log('Success:', values);
    if (values.startDate) {
      newStartDate = values.startDate._d.toUTCString();
      newStartDate = new Date(newStartDate).toISOString().slice(0, 19).replace('T', ' ');
    }
    if (values.endDate) {
      console.log('in end date if');
      newEndDate = values.endDate._d.toUTCString();
      newEndDate = new Date(newEndDate).toISOString().slice(0, 19).replace('T', ' ');
    }
    console.log(newEndDate, newEndDate);
    if (newStartDate > newEndDate) message.error('Start date must be less than or equal to end date');
    setReportObj({
      organizationId: values.organizationId ? values.organizationId : null,
      causeId: values.causeId ? values.causeId : null,
      startDate: values.startDate ? newStartDate.slice(0, 50) + ' 00:00:00' : null,
      endDate: values.endDate ? newEndDate.slice(0, 50) + ' 23:59:59' : null,
      status: values.status ? values.status : null,
    });
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const cancelRecurr = async (payloadObj) => {
    try {
      console.log("cancelRecurr", cancelRecurr)
      // let cancelContractQuery = 
      // const queryResponse = {
      //   data: {
      //     "statusCode": 200,
      //     "success": true,
      //     "data": "Contract cancelled",
      //     "message": "Recurring Contract Cancelled successfully",
      //   },
      // }
      const queryResponse = await axios.post(`${app.URL}/merchantportal/cancelcontract`, payloadObj);

      console.log("queryResponse", queryResponse);
      // if (queryResponse.code == 200) {
        setOrderCancelResp(queryResponse.data);
      
      // }
    } catch (error) {
      console.log("error",error)
    }
  }
  const cancelContract = async (payload) => {
 try {
   console.log("payload", user.userType,payload);
   // console.log(payload);



  //  return
   let payloadObj = {
     donorId: payload?.donorId,
     recurringId:payload?.recurringId,

    //  recurringId: user.userType == 'O' ? Number(payload?.mxPortalContractId) :payload?.recurringId,
     organizationId: payload?.organizationId,
     contractId: payload?.mxRecurrContractId
   };
  //  return
   await cancelRecurr(payloadObj)
   setisload(true)
   setTimeout(() => {
     setCancelShow(false);
     setOrderCancelResp()

   }, 1000);
   setisvisible(false)
 } catch (error) {
   console.log("error", error)

 }
  
  };
  console.log(reportObj);
  const handleCancelModalClose = () => setCancelShow(false);

  useEffect(() => {
    if (Object.keys(reportObj).length > 0) fetchData(reportObj);
  }, [reportObj]);
  useEffect(() => {
    const userList = async () => {
      console.log('user list function called');
      const donorId = JSON.parse(localStorage.getItem('donorId'));
      const limit = 1000;
      const offset = 0;
      basicModal && basicModal==true? setBasicModal(false):''
      let convertedObj;
      let fetchQuery;
      if (user.userType === 'O' && window.location.pathname === '/recurring/bydonerorg') fetchQuery = `${app.URL}/recurring/viewbydonorandorg/${donorIdforRecurring}/${user.organizationId}`;
      if (user.userType === 'A' && window.location.pathname === '/recurring/bydoner') fetchQuery = `${app.URL}/recurring/viewbydonorid/${donorIdforRecurring}`;
      if (user.userType === 'O' && window.location.pathname === '/orgreport/recurring') fetchQuery = `${app.URL}/recurring/viewbyorg?orgId=${user.organizationId}`;
      if (user.userType === 'A' && window.location.pathname === '/reports/recurring') fetchQuery = `${app.URL}/recurring/view`;
      console.log(fetchQuery);
      const userResp = await axios.post(fetchQuery, { limit, offset }, { headers: { auth: token } });
      console.log('🚀 ~ file: Users.js:31 ~ userList ~ userResp', userResp.data.data);
      userResp.data ? setDonorDataList(userResp.data.data) : ' ';
      userResp.data ? (convertedObj = dateConverter(userResp.data.data, 'startDate')) : ' ';
      userResp.data ? (convertedObj = dateConverter(convertedObj, 'creationDate')) : ' ';
      userResp.data ? setFetchUsers(convertedObj) : ' ';
      userResp.data ? setPagesCount(convertedObj.length) : ' ';
      userResp.data ? setisload(false) : ' ';

      userResp.data ? setRenderList(convertedObj.slice(0, 50)) : ' ';
      userResp.data.data
        ? userResp.data.data.forEach((ele) => {
            console.log(ele);
            donorArray.push({ value: ele.donorId, label: ele.firstName + ' ' + (ele.lastName ? ele.lastName : ' ') });
          })
        : ' ';
    };
    userList();
    if ((window.location.pathname === '/orgreport/recurring' || window.location.pathname === '/recurring/bydonerorg') && user.userType === 'O') {
      console.log(user);
      console.log(donorId)
      fetchRecurrings(user.organizationId,null,null,donorId);
    } else {
      fetchRecurrings();
    }
  }, [window.location.pathname, donorId, isload]);
  console.log(donorDataList);
  user.userType == 'O' && donorDataList
    ? donorDataList.forEach((ele) => {
        donorArray.push({ value: ele.donorId, label: ele.firstName + ' ' + (ele.lastName ? ele.lastName : ' ') });
      })
    : ' ';

  donorArray = removeDuplicatesByKey(donorArray, 'value');

  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchUsers.slice(reqObj.offset, reqObj.offset + limit));
    // if(users){
    //   console.log("users")
    //   setRenderList(users)
    // }
    console.log(renderList);
  };

  const handleClearClick = () => {
    console.log('handleClearClick');
    form.resetFields();
    setDonorId('');
  };

  console.log(renderList);
  console.log(currRecurr);

  //Search functionality for donor
  const ondonorChange = (value) => {
    console.log(`selected ${value}`);
    setDonorId(value);
  };
  const ondonorSearch = (value) => {
    console.log('search:', value);
  };

  const getPayments = async (mxId, orgId) => {
    const getRequest = await axios.get(`${app.URL}/merchantportal/contractpayments?organizationId=${orgId}&mxRecurrContractId=${mxId}`, { headers: { auth: token } });
    console.log(getRequest);
    getRequest.data.data.recordCount === 0 && message.warn('No record found!');
    getRequest.data.data.recordCount > 0 && setPaymentDetails(getRequest.data.data.records);
    getRequest.data.data.recordCount > 0 && setPaymentModal(true);
  };
  console.log("fetchUsers", fetchUsers)
  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row mt-2'>
        <div className='col-lg-12 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Recurring Report')}</div>
        <div className='row mt-3 ml-1'>
          <Form
            name='basic'
            form={form}
            className='ml-5'
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 8,
            }}
            style={{ alignItems: 'flexEnd' }}
            // style={{
            //   maxWidth: 600,
            // }}
            initialValues={{
              remember: true,
              // ['organizationId']: organizationId?organizationId:null,
              // ['causeId']: causeId?causeId:null,
              // ['donorId']:donorId?donorId:null,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <Row gutter={[16, 16]}>
              {user.userType === 'A' ? (
                <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={5}>
                  <Form.Item
                    colon={false}
                    name='organizationId'
                    style={{ width: '680px' }}
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <Select
                      listHeight={250}
                      listItemHeight={500}
                      style={{
                        width: 200,
                      }}
                      placeholder='Select Organization'
                    >
                      {orgObj.map((org) => {
                        return (
                          <Option key={org.organizationId} value={org.organizationId}>
                            {org.organizationName}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              ) : (
                ' '
              )}
              {window.location.pathname === ('/recurring/bydonerorg' && '/recurring/viewbydonorid') ? (
                ''
              ) : (
                <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
                  <Form.Item
                    colon={false}
                    name='donorId'
                    style={{ width: '680px' }}
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    {/* <Select
                    listHeight={250}
                    listItemHeight={500}
                    style={{
                      width: 160,
                    }}
                    placeholder='Select Donor'
                  >
                    {donorList.map((donor) => {
                      return (
                        <Option key={donor.donorId} value={donor.donorId}>
                          {donor.firstName+' '+(donor.lastName?donor.lastName:" ")}
                        </Option>
                      );
                    })}
                  </Select> */}
                    <Select showSearch placeholder='Select donor' optionFilterProp='children' onChange={ondonorChange} onSearch={ondonorSearch} style={{ width: '158px' }} filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())} options={donorArray} />
                  </Form.Item>
                </Col>
              )}
              <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
                <Form.Item
                  colon={false}
                  name='causeId'
                  style={{ width: '680px' }}
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    style={{
                      width: 160,
                    }}
                    placeholder='Select Cause'
                  >
                    {causes.map((cause) => {
                      return (
                        <Option key={cause.causeId} value={cause.causeId}>
                          {cause.cause}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
                <Form.Item
                  colon={false}
                  style={{
                    width: 550,
                  }}
                  name='startDate'
                  rules={[
                    {
                      required: false,
                      message: 'Please select date!',
                    },
                  ]}
                >
                  <DatePicker placeholder='Date From' />
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
                <Form.Item
                  colon={false}
                  name='endDate'
                  style={{
                    width: 550,
                  }}
                  rules={[
                    {
                      required: false,
                      message: 'Please select date!',
                    },
                  ]}
                >
                  <DatePicker placeholder='Date To' />
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
                <Form.Item
                  colon={false}
                  name='status'
                  style={{ width: '680px' }}
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    style={{
                      width: 160,
                    }}
                    placeholder='Select status'
                  >
                    <Option value='Active'>Active</Option>
                    <Option value='Cancelled'>Cancelled</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={2}>
                <Form.Item colon={false}>
                  <button className='btn btn-primary button' onClick={handleClearClick}>
                    Clear
                  </button>
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={3}>
                <Form.Item>
                  <button type='primary' class='btn btn-primary button' htmlType='submit'>
                    Search
                  </button>
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={3}>
                <CSVLink className='excel-btn' icon={faFileExcel} filename={'recurring-report.csv'} data={fetchUsers}>
                  <img style={{ marginTop: '-5px' }} src='/excel.png' />
                </CSVLink>
              </Col>
            </Row>
          </Form>
          <div>
            <b>Total Recurrings:</b> ${recurrings.toFixed(2)}
          </div>
        </div>
      </div>
      <div className='col-lg-12 col-md-12 col-sm-12 '>
        <div className='styled-table' style={{overflow:"auto", padding:"0px !important"}}>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                {/* <th>{t("ID")}</th> */}
                <th style={{ width: '100px' }}>{t('Recurring ID')}</th>
                <th style={{ width: '100px' }}>{t('Contract ID')}</th>
                {user.userType === 'A' ? <th>{t('Organization')}</th> : ' '}
                <th>{t('Donor')}</th>
                <th>{t('Cause')}</th>
                <th>{t('Donation')}</th>
                <th>{t('Frequency')}</th>
                <th>{t('Start Date')}</th>
                {/* <th style={{ width:'20px'}}>{t('Occurrences')}</th> */}
                <th>{t('Status')}</th>
                {/* <th></th> */}
                <th></th>
                <th></th>
                {/* {user.userType==="A"?<th>{t("Organization")}</th>:""}  */}
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    // onClick={()=>{editUser(output)}}
                    <tr className='row-hover'>
                      {/* <td >{output.userId}</td> */}
                      <td style={{ width: '30px' }}>{output.mxPortalContractId}</td>
                      <td style={{ width: '50px' }}>{output.mxRecurrContractId}</td>
                      {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                      {user.userType === 'A' ? <td style={{ width: '160px' }}>{output.organizationName}</td> : ' '}
                      <td style={{ width: '250px' }}>
                        {output.firstName} {output.lastName}
                      </td>
                      <td style={{ width: '130px' }}>{output.cause}</td>
                      <td style={{ width: '50px' }}>$ {output.amount}</td>
                      <td style={{ width: '80px' }}>{output.paymentInterval}</td>
                      <td style={{ width: '180px' }}>{output.startDate}</td>
                      {/* <td style={{ width: '10px'}}>{output.occurrences}</td> */}
                      <td style={{ width: '80px' }}>{output.isActive}</td>
                      {/* <td style={{ width: '40px' }}>
                      <button onClick={()=>{onPaymentClick(output)}} className='btn button btn-primary recurr-btn '>Payments</button>
                      </td>   */}
                      <td style={{ width: '40px' }}>
                        <button onClick={() => toggleShow(output)} className='btn button btn-primary recurr-btn '>
                          Detail
                        </button>
                      </td>
                      <td style={{ width: '40px' }}>
                        <button onClick={() => getPayments(output.mxRecurrContractId, output.organizationId)} className='btn button btn-primary recurr-btn '>
                          Payments
                        </button>
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
          {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Contract ID: {currRecurr.mxRecurrContractId}</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row '>
                      <div className='col-lg-4 mt-1'>Organization </div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={currRecurr.organizationName} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Donor </div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={`${currRecurr.firstName} ${currRecurr.lastName}`} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Cause</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={currRecurr.cause} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Donation</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={`$ ${currRecurr.amount}`} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Frequency</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={currRecurr.paymentInterval} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Kiosk</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='-' value={currRecurr.kioskTitle} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Creation Date</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='-' value={currRecurr.creationDate != 'Invalid date' ? moment(currRecurr.creationDate).format('D MMM YYYY , h:mm:ss'):'-'} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Start Date</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={currRecurr.startDate} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Occurrences</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Unlimited' value={currRecurr.occurrences} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row '>
                      {/* `${currRecurr.dayType}` */}
                      <div className='col-lg-4 mt-1'>{currRecurr.paymentInterval === 'Yearly' ? 'On Every' : 'On Every'}</div>
                      <div className='col-lg-4'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={currRecurr.paymentInterval === 'Yearly' ? `${currRecurr.startDate.slice(3, 6)}` : currRecurr.paymentInterval === 'Weekly' ? `${currRecurr.paymentDay}` : `${currRecurr.dayType}`} />
                      </div>
                      {/* <div className='col-lg-3 mt-1'>Day Number</div> */}
                      <div className='col-lg-3'>
                        <input type='text' id='disabledTextInput' class='form-control pl-9 ' placeholder='Disabled input' value={currRecurr.dayNumber} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset disabled>
                  <div class='form-group mt-2'>
                    <div className='row'>
                      <div className='col-lg-4 mt-1'>Status</div>
                      <div className='col-lg-7'>
                        <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={currRecurr.isActive} />
                      </div>
                      {/* <div className='col-lg-7'>{currRecurr.isActive==="Active"?<CheckCircleFilled style={{color:"#0a466b", fontSize:"25px"}}/>:<CloseCircleFilled style={{color:"red", fontSize:"25px"}}/>}</div> */}
                    </div>
                  </div>
                </fieldset>
              </form>
            </MDBModalBody>

            <MDBModalFooter>
              {visible &&
                <button className='btn button btn-primary' color='secondary' onClick={() => setCancelShow(true)}>
                  Cancel Contract
                </button>
              }
              {/* <button className='btn button btn-primary' color='secondary' onClick={cancelContract(currRecurr)}>
                Cancel Contract
              </button> */}
              <button className='btn button btn-primary' color='secondary' onClick={toggleShow}>
                Close
              </button>
              {/* <MDBBtn>Save changes</MDBBtn> */}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal show={paymentModal} setShow={setPaymentModal} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              {/* <MDBModalTitle>Payment ID: {paymentDetils.id}</MDBModalTitle> */}
              <MDBBtn className='btn-close' color='none' onClick={togglePaymentShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {paymentDetils.map((item) => (
                <Card
                  style={{
                    // width: 300,
                    margin: '1rem 0rem',
                    boxShadow: 'none',
                  }}
                  key={item.id}
                >
                  <div className='container-fluid'>
                    <div className='row'>
                      <div className='col-md-8'>
                        <h2 className='m-0 fw-bold'>ID: {item.id}</h2>
                      </div>
                      <div className='col-md-4 text-right'>
                        <span
                          className={`m-0 text-light p-1 px-2 rounded 
                        ${item.status === 'Approved' ? 'bg-warning' : item.status === 'Settled' ? 'bg-success' : 'bg-danger'}`}
                        >
                          {item.status}
                        </span>
                      </div>
                    </div>
                    <div className='row mt-1'>
                      <p className='col-md-12 m-0'>Name: {item.creatorName}</p>
                      <p className='col-md-12 m-0'>Amount: {item.amount}</p>
                      <p className='col-md-12 m-0'>Settled Amount: {item.settledAmount}</p>
                      <p className='col-md-12 m-0'>Settled Date: {moment(item.settledDate).format('MM-DD-YYYY')}</p>
                      {item.refundedAmount && <p className='col-md-12 m-0'>Refunded Amount: {item.refundedAmount}</p>}
                    </div>
                  </div>
                </Card>
              ))}
            </MDBModalBody>

            <MDBModalFooter>
              <button className='btn button btn-primary' color='secondary' onClick={togglePaymentShow}>
                Close
              </button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>









      {orderCancelResp && orderCancelResp.statusCode === 200 ? (
        <Modal show={cancelShow} onHide={handleCancelModalClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>{orderCancelResp.message}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : orderCancelResp && orderCancelResp.statusCode === 400 ? (
        <Modal show={cancelShow} onHide={handleCancelModalClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Failed</Modal.Title>
          </Modal.Header>
            <Modal.Body>{orderCancelResp.message}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <Modal show={cancelShow} onHide={handleCancelModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to cancel shipment?</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleCancelModalClose}>
              Cancel
            </Button>
                <Button variant='primary' htmlType='submit' onClick={()=>cancelContract(currRecurr)}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}





    </div>


    
    
    

    //     </div>
    //   </div>
    // </div>
  );
}

export default RecurringDetails;

